import "./About.css";

const features = [
  { icon: "🌾", title: "Langsung dari Pembudidaya", desc: "Kualitas tanaman terjamin dari sumber terpercaya" },
  { icon: "🏅", title: "Berlisensi & Profesional", desc: "Tim bersertifikat dan berpengalaman di bidangnya" },
  { icon: "🛡️", title: "Garansi 3 Bulan", desc: "Perlindungan proyek untuk ketenangan Anda" },
  { icon: "🗺️", title: "Kirim Se-Indonesia", desc: "Jangkauan pengiriman ke seluruh nusantara" },
];

export default function About() {
  return (
    <section className="about" id="tentang">
      <div className="container about__inner">

        {/* Left */}
        <div className="about__visuals anim-left">
          <div className="about__img-wrap">
            <img
              src="https://images.unsplash.com/photo-1615671524827-c1fe3973b648?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?w=800&auto=format&fit=crop"
              alt="Tim Gemburin bekerja"
            />
          </div>
          <div className="about__float-card">
            <div className="about__float-icon">🌱</div>
            <div>
              <div className="about__float-num">10+</div>
              <div className="about__float-lbl">Tahun Pengalaman</div>
            </div>
          </div>
        </div>

        {/* Right */}
        <div className="about__text anim-right">
          <span className="eyebrow">Tentang Kami</span>
          <h2 className="about__title">
            Perusahaan Keluarga, <em>Fokus pada Pelanggan</em>
          </h2>
          <p className="about__body">
            Gemburin Sejahtera adalah perusahaan kontraktor penghijauan berbasis di Kediri, Jawa Timur.
            Berdiri lebih dari satu dekade, kami melayani berbagai klien mulai dari perumahan, perkantoran,
            kawasan industri, hingga proyek infrastruktur negara.
          </p>
          <p className="about__body">
            Dengan misi menciptakan lingkungan yang lebih hijau dan sehat, kami hadir dengan solusi
            landscape taman, reboisasi, dan suplai tanaman berkualitas ke seluruh Indonesia.
          </p>

          <div className="about__features">
            {features.map(f => (
              <div className="about__feat" key={f.title}>
                <div className="about__feat-icon">{f.icon}</div>
                <div>
                  <h4>{f.title}</h4>
                  <p>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <a href="#layanan" className="btn btn-green">Jelajahi Layanan Kami</a>
        </div>

      </div>
    </section>
  );
}
